export const environment = {
  production: true,
  apiUrl: 'https://seminar-web-component.cloud.rohde-schwarz.com/v1',
  stage: 'prod'
};
